import config from '../../../../config';
import Request from '../../../Request';

export default function index(itemCategoryId, onSuccess, onFailure) {
  return Request.get(`${config.apiUrl}/item_categories/${itemCategoryId}/reservation_questions`, onSuccess, onFailure);
}